import { IWykrojnikRow } from "./IWykrojnikRow";

export class wykrojnik_api {

    public static selected:IWykrojnikRow|undefined=undefined

    public static get_selected_wykrojnik_for_tree:string = "/api/wykrojnik/get_selected_wykrojnik_for_tree"
    public static del_selected_wykrojnik_for_tree:string = "/api/wykrojnik/del_selected_wykrojnik_for_tree"
    public static save_selected_wykrojnik_for_tree:string = "/api/wykrojnik/save_selected_wykrojnik_for_tree"
    public static save_manual_wykrojnik_for_tree:string = "/api/wykrojnik/save_manual_wykrojnik_for_tree"


    public static eq(w1:IWykrojnikRow|undefined, w2:IWykrojnikRow|undefined):number {
        if (w1==undefined) return 0;
        if (w2==undefined) return 0;
        if (w1.origin!=w2.origin) return 0;
        if (w1.ux!=w2.ux) return 0;
        if (w1.uy!=w2.uy) return 0;
        if (w1.numer!=w2.numer) return 0;
        return 1
    }



}

export interface IWykrojnikSvc {

    get_selected_wykrojnik_for_tree(tree_id:string):Promise<IWykrojnikRow | undefined>;
    del_selected_wykrojnik_for_tree(tree_id:string):Promise<IWykrojnikRow | undefined>;
    save_selected_wykrojnik_for_tree(param:IWykrojnikRow):Promise<IWykrojnikRow | undefined>;
    save_manual_wykrojnik_for_tree(param:IWykrojnikRow):Promise<IWykrojnikRow | undefined>;

}
      
  